import React, { useCallback, useState, useEffect } from 'react';
import SelectField from '../../../uikit/inputs/SelectField';
import { noop } from '../../../utils/noop';
import { useOnDepsUpdate } from '../../../hooks/useOnDepsUpdate.hook';
function shouldSetSafeOption(options, value) {
    if (options.length === 0) {
        return false;
    }
    return (typeof value === 'undefined' ||
        !options.find(function (option) { return option.value === value; }));
}
export function BaseSelect(_a) {
    var name = _a.name, placeholder = _a.placeholder, _b = _a.options, options = _b === void 0 ? [] : _b, value = _a.value, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.onChange, onChange = _d === void 0 ? noop : _d, _e = _a.onBlur, onBlur = _e === void 0 ? noop : _e, _f = _a.onFocus, onFocus = _f === void 0 ? noop : _f;
    var _g = useState(function () {
        if (shouldSetSafeOption(options, value)) {
            return options[0].value;
        }
        return value;
    }), selectedValue = _g[0], setSelectedValue = _g[1];
    useOnDepsUpdate(function () {
        if (shouldSetSafeOption(options, value)) {
            setSelectedValue(options[0].value);
        }
        setSelectedValue(value);
    }, [value]);
    useEffect(function () {
        if (shouldSetSafeOption(options, value)) {
            onChange(options[0].value);
            setSelectedValue(options[0].value);
        }
    }, [options, onChange, value]);
    var handleChange = useCallback(function (ev) {
        var nextValue = ev.target.value;
        setSelectedValue(nextValue);
        onChange(nextValue, ev);
    }, [onChange]);
    var handleBlur = useCallback(function (e) {
        // @todo: SUI Select emit event from div-wrapper at desktop
        // now it fixed with useState, but may lead to errors
        selectedValue && onBlur(selectedValue, e);
    }, [onBlur, selectedValue]);
    return (React.createElement(SelectField, { name: name, placeholder: placeholder, value: selectedValue, error: error, onChange: handleChange, options: options, onBlur: handleBlur, onFocus: onFocus }));
}
